// MATERIAL-UI
import { Grid, Typography } from "@mui/material";

// COMPONENTS
import ConfirmButton from "./ConfirmButton";

interface propType {
  customMessage?: string;
  hideButton?: boolean;
  halfSize?: boolean;
  onClose?: (event: any) => void;
}

const GenericMessageModal = (props: propType) => {
  const successText =
    "You've successfully submitted an address for approval. Please check your email to test this address";
  return (
    <Grid container justifyContent="center" alignItems="center" p={5}>
      <Typography style={{ fontSize: "24px", fontWeight: 600, textAlign: "center" }}>
        {props.customMessage ? props.customMessage : successText}
      </Typography>
      {!props.hideButton && (
        <ConfirmButton has2FA={true} height={48} title="Close" onClick={props.onClose} />
      )}
    </Grid>
  );
};

export default GenericMessageModal;
